import React from "react";
import PropTypes from "prop-types";
// import DocumentService from "services/documents-service";
import cx from "classnames";
import { 
    Form,
    Row,
    Col,
    Upload,
    Button,
    message,
    Icon
} from "antd";
import moment from "moment";
import { OrderedMap } from "immutable";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { AddressRecord, AssociateRecord } from "records/company-record";
import { APPLICANT_FIELDS } from "constants/form-fields";
import { BASE_URL } from "constants";
import { getAuthToken } from "utilities/auth";

const DocumentsList = new OrderedMap({
    pan: {
        title: "Upload PAN",
        applicantDocumentId: 7,
        gurantorDocumentId: 12,
        key: 7
    },
    aadhar: {
        title: "Upload Aadhar",
        applicantDocumentId: 8,
        gurantorDocumentId: 13,
        key: 8
    },
    photo: {
        title: "Upload Photo",
        applicantDocumentId: 6,
        gurantorDocumentId: 6,
        key: 6
    }
});

export const UploadDocumentComponent = (caseId, title, companyId, documentId, docUploadResult) => {
    return (
        <Upload
            key={"upload"}
            {...{
                directory: false, // Upload Directory Support
                multiple: true, // Upload Multiple files support,
                action:
                    `${BASE_URL}/case/${caseId}/document/upload/`,
                showUploadList: true,
                headers: {
                    Authorization: `Bearer ${
                        getAuthToken().authToken
                    }`
                },
                data: file => {
                    message.loading("Uploading File...", 0);
                    return  {
                        file_name: file.name,
                        company: companyId,
                        document: documentId
                    };
                    // }
                },
                onChange: ({ file }) => {
                    if (file.status === "done") {
                        message.destroy();
                        docUploadResult(documentId, file.response);
                        message.success("File Uploaded");
                    }
                    if(file.status === "error") {
                        message.destroy();
                        message.error("Failed to Upload file");
                    }
                }
            }}
        >
            <Button
                className={"d-flex justify-content-space-between align-items-center"} 
                style={{
                    cursor: "pointer",
                    // marginBottom: "20px",
                    // marginTop: "20px",
                    width: "200px",
                    height: "50px"
                }}
            >
                <span>{title}</span><Icon type={"upload"} />
            </Button>
        </Upload>
    );
};

class ApplicantDataParser extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    handleFormSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, {residence_address, ...restValues}) => {
            if (!err) {
                this.props.onFormSubmit(
                    this.props.associateId,
                    new AssociateRecord({ ...restValues, company: this.props.companyId, type: this.props.associateType }),
                    new AddressRecord({
                        ...residence_address,
                        associate: restValues.associate,
                        company: this.props.companyId
                    }),
                    this.documentsList
                );
            }
        });
    }

    documentsList = {};

    onSuccessfulUpload = (docId, data) => {
        if(data && data.parse_data_formatted) {
            let applicantData = data.parse_data_formatted;
            this.documentsList = {
                ...this.documentsList,
                [data.id]: data
            };
            if([7, 12].includes(docId)) {
                this.props.form.setFieldsValue({
                    first_name: applicantData && applicantData.first_name,
                    dob: applicantData && moment(applicantData.formatted_dob),
                    pan: applicantData && applicantData.pan
                });
            }
            if([8, 13].includes(docId)) {
                this.props.form.setFieldsValue({
                    residence_address: applicantData && new AddressRecord({
                        ...applicantData.address,
                        address_type: 5,
                        is_communication_address: true,
                        company: this.props.companyId
                    })
                });
            }
        }

    }

    getDocumentsForm = () => {
        return (
            <div className={"d-flex flex-column"}>
                {DocumentsList.map(_ => (
                    <div key={_.key} style={{
                        marginBottom: "20px",
                        marginTop: "20px",
                    }}>
                        {UploadDocumentComponent(
                            this.props.caseId,
                            _.title,
                            this.props.companyId,
                            this.props.associateType === 1 ? _.applicantDocumentId : _.gurantorDocumentId,
                            this.onSuccessfulUpload
                        )}
                    </div>
                )).toList().toArray()}
            </div>
        );
    }

    getApplicantDetailForm = () => {
        return (
            <Form
                layout="vertical"
                // onSubmit={}
                className={cx("form")}
            >
                <div>
                    {APPLICANT_FIELDS
                        .filter((_, k) => !["type", "middle_name"].includes(k))
                        .map((field, fieldName) => {
                            return this.fieldGenerator(fieldName, {...field, label: field.placeholder}, this.getErrorOnField(fieldName))();
                        })
                        .toList()}
                </div>
            </Form>
        );
    }

    render() {
        return (
            <Row className={"p-5"}>
                <Col className={"p-5 d-flex flex-column"} span={12}>
                    <span style={{fontSize: "12px", fontWeight: "bold"}}>
                        {"Upload Documents"}
                    </span>
                    {this.getDocumentsForm()}
                </Col>
                <Col className={"p-5 d-flex flex-column"} span={12}>
                    <span style={{fontSize: "12px", fontWeight: "bold", marginBottom: "20px"}}>
                        {"Applicant Details"}
                    </span>
                    {this.getApplicantDetailForm()}
                </Col>
                <Col className={"p-5 d-flex justify-content-flex-end"} span={24}>
                    <Button type={"primary"} className={"mr-5"} onClick={this.handleFormSubmit}>Save</Button>
                    <Button type={"default"} onClick={this.props.closeModal}>Cancel</Button>
                </Col>
            </Row>
        );
    }

}

ApplicantDataParser.propTypes = {
    form: PropTypes.object,
    onFormSubmit: PropTypes.func,
    closeModal: PropTypes.func,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associateType: PropTypes.number,
    associateId: PropTypes.string
};

export default Form.create({})(ApplicantDataParser);
